import React from "react";
import UIKit from "../UIKit";

const Loader = () => {
    return <UIKit.Spinner />;
};

export default Loader;
